[
  {
    "id": "usd",
    "title": "USD",
    "flag": "us",
    "symbol": "$"
  },
  {
    "id": "eur",
    "title": "EUR",
    "flag": "eu",
    "symbol": "€"
  },
  {
    "id": "lek",
    "title": "LEK",
    "flag": "al",
    "symbol": "L"
  }
]
